import React from 'react'
import { useFilter, useOrdering } from 'storfox-filter'
import { ALTER_ERROR, useSnackbar } from 'storfox-snackbar'

import { DashboardLayout } from '~/components/Layouts'
import * as NAV from '~/constants/nav-titles'
import ErrorLink from '~/components/ErrorLink'
import useMessages from '~/hooks/useMessages'

import { useLocationUnitReportList, useLocationUnitGenerate } from '../../hooks/LocationUnit'
import UnitList from '../../components/LocationUnit/UnitList'
import UnitOrderingForm, { inventoryOrderingOptions } from '../../components/LocationUnit/UnitOrderingForm'
import UnitFilterForm, { inventoryFilterOptions } from '../../components/LocationUnit/UnitFilterForm'

function LocationUnitReportListContainer () {
  const messages = useMessages()

  const unitList = useLocationUnitReportList()
  const unitLocationGenerate = useLocationUnitGenerate()

  const snackbar = useSnackbar()

  const filter = useFilter(inventoryFilterOptions)
  const ordering = useOrdering(inventoryOrderingOptions)

  const handleReportGenerate = () =>
    unitLocationGenerate.export()
      .then(() => snackbar({ message: messages.NOTIFICATION_WAIT }))
      .catch(error => {
        const message = <ErrorLink error={error} />
        snackbar({ message, type: ALTER_ERROR })
      })

  const breadcrumbs = { title: NAV.LOCATION_UNITS_REPORT }

  return (
    <DashboardLayout
      title={NAV.LOCATION_UNITS_REPORT}
      activeNav={NAV.REPORTS}
      breadcrumbs={breadcrumbs}
    >

      <UnitFilterForm {...filter} />
      <UnitOrderingForm {...ordering} />

      <UnitList
        list={unitList}
        filter={filter}
        ordering={ordering}
        onListRefetch={unitList.getListByParams}
        handleOpenFilter={filter.handleOpen}
        onReportGenerate={handleReportGenerate}
      />
    </DashboardLayout>
  )
}

export default LocationUnitReportListContainer
